import { CANCEL_APPROVAL_TYPES } from '@/constant';

export { default as WorkingHoursChangeSlot } from './WorkingHoursChangeSlot';
export { default as OvertimeApplySlot } from './OvertimeApplySlot';
export { default as ToilTimeUseSlot } from './ToilTimeUseSlot';
export { default as AnnualLeaveSlot } from './AnnualLeaveSlot';
export { default as CancelTargetSlot } from './CancelTargetSlot';
export { default as useAttendanceCancel } from './useAttendanceCancel';

/**
 * 자가결재 근태 품의 — 결재라인이 기안자 1인(상신 즉시 승인)이라 레거시 조회 폼도 결재라인을 숨김.
 * 취소 품의(CANCEL_APPROVAL_TYPES)는 실제 결재라인을 타므로 제외.
 */
export const SELF_APPROVAL_ATTENDANCE_TYPES: readonly number[] = [
  222, 223, 224, 231,
];

/** 본문이 HTML 이 아니라 attributes(+v1 상세) 로 그려지는 근태 유형 전체 */
export const ATTENDANCE_CONTENT_TYPES: readonly number[] = [
  ...SELF_APPROVAL_ATTENDANCE_TYPES,
  ...CANCEL_APPROVAL_TYPES,
];

export const isSelfApprovalAttendanceType = (apvType: number): boolean =>
  SELF_APPROVAL_ATTENDANCE_TYPES.includes(apvType);

export const isAttendanceContentType = (apvType: number): boolean =>
  ATTENDANCE_CONTENT_TYPES.includes(apvType);
